/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Bridge_Connector_BoundInputs */



/**
* | output |
* | --- |
* | "Connector-bound · access inherited from the integration · no stored credential" |
*
* @param {Api_Bridge_Connector_BoundInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_bridge_connector_bound = /** @type {((inputs?: Api_Bridge_Connector_BoundInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Bridge_Connector_BoundInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Connector-gebunden · Zugriff von der Integration geerbt · keine gespeicherten Zugangsdaten")
	return /** @type {LocalizedString} */ ("Connector-bound · access inherited from the integration · no stored credential")
});